import { render, staticRenderFns } from "./StepFooter.vue?vue&type=template&id=202f1256&scoped=true&"
import script from "./StepFooter.vue?vue&type=script&lang=js&"
export * from "./StepFooter.vue?vue&type=script&lang=js&"
import style0 from "./StepFooter.vue?vue&type=style&index=0&id=202f1256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f1256",
  null
  
)

export default component.exports